export default () => ({
  companyStatitics: ''
})



// WEBPACK FOOTER //
// ./src/app/patient/profile-company/components/statistics/resources/data.js